import React, { Fragment } from 'react'

import GridLayout from '../components/layout/GridLayout'
import Module from '../components/Module'
import Title from '../components/typography/Title'
import Button from '../components/Button'

const readMoreHref =
  'https://investors.sonos.com/news-and-events/investor-news/latest-news/2019/Sonos-Announces-Acquisition-of-Snips/default.aspx'

export default function SonosAquisitionPage () {
  return (
    <main className='main'>
      <GridLayout extraClass='section-standard-bottom-margin'>
        <Module
          extraClass='grid-col-1-13 aquisition-page__container-module'
          contentExtraClass='grid-two-columns grid-gap-7 aquisition-page__container-module__content'
        >
          <div />
          <Module
            theme='custom'
            extraClass='aquisition-page__content-module'
            withPin={false}
          >
            <Fragment>
              <Title size={2} extraClass='blue fluid-mb2 light'>
                Snips Acquired by Sonos
              </Title>
              <p className='fluid-mb2'>
                Snips is excited to announce that it is joining the Sonos family
                to bring embedded voice recognition to brilliant sound and
                beyond.
              </p>
              <p className='fluid-mb6'>
                We will continue to operate out of Paris, France as the Sonos
                Voice Experience team that includes product and business
                development.
              </p>
              <Button forceAnchorElement href={readMoreHref}>
                Read more
              </Button>
            </Fragment>
          </Module>
        </Module>
      </GridLayout>
    </main>
  )
}
